<template>
	<div>
		<div class="area1">
			<div class="leftArea">
				<img class="leftLogo" mode="widthFix" src="../../static/bottomPic/logo_hudie1@2x.png"/>
				<div class="qrCodeLan">
					<div class="qrCodeBox">
						<!-- <img class="qrCode" mode="widthFix" src="../../static/bottomPic/download_c@2x.png"/> -->
						<img class="qrCode" mode="widthFix" src="../../static/downLoadPic/customer.png"/>
						
						<div class="qrtxt">扫码下载APP</div>
					</div>
					<div class="qrCodeBox">
						<img class="qrCode" mode="widthFix" src="../../static/downLoadPic/seller.jpg"/>
						<div class="qrtxt">商家端下载</div>
					</div>
					<div class="qrCodeBox">
						<img class="qrCode" mode="widthFix" src="../../static/bottomPic/download_gzh@2x.png"/>
						<div class="qrtxt">微信公众号</div>
					</div>
					<div class="qrCodeBox">
						<img class="qrCode" mode="widthFix" src="../../static/bottomPic/img_douyinhao@2x.png"/>
						<div class="qrtxt">官方抖音号</div>
					</div>
				</div>
			</div>
			
			<div class="rightArea">
				<div class="phoneTitle">官方热线</div>
				<div class="phone">400-688-6999</div>
				<div class="phoneTitle">商务合作</div>
				<div class="phone">18200000003</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name:'mobile-bottom-area',
		data() {
			return {

			}
		},
		created() {

		},
		methods: {

		}
	}
</script>

<style scoped="scoped">
	.area1{
		display: flex;
		flex-direction: row;
		width: 100%;
		margin-top: 30px;
		height: 160px;
		background: #242B34;
		text-align: left;
		position: relative;
		bottom: 0px;
		/* margin-bottom: 100px; */
	}
	.leftArea{
		padding-left: 15px;
		width: calc(55% - 15px);
		/* height: 100%; */
	}
	.rightArea{
		width: 45%;
		/* height: 100%; */
		display: flex;
		flex-direction: column;
	}
	.leftLogo{
		width: 200px;
		height: 33px;
		margin-top: 25px;
	}
	.qrCodeLan{
		margin-top: 18px;
		width: 100%;
		display: flex;
		justify-content: space-between;
	}
	.qrCodeBox{
		width: 43px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.qrCode{
		width: 43px;
	}
	.qrtxt{
		margin-top: 8px;
		width: 100%;
		text-align: center;
		font-size: 6px;
		font-family: Source Han Sans SC;
		font-weight: bold;
		color: #FFFFFF;
	}
	.phoneTitle{
		margin-left: 60px;
		margin-top: 25px;
		font-size: 8px;
		font-family: Source Han Sans SC;
		font-weight: bold;
		color: #FFFFFF;
	}
	.phone{
		font-size: 15px;
		margin-left: 60px;
		font-family: Source Han Sans SC;
		font-weight: 500;
		color: #FFFFFF;
		margin-top: 5px;
	}
</style>
